import React, { memo, useEffect, useMemo, useRef } from "react";
import OverviewListLayout from "@icoach/components/overviewList/OverviewListLayout";
import useOrderStatisticsApi from "@apis/useOrderStatisticsApi";
import useOptions from "@util/hook/useOptions";
import useOverview from "@util/hook/useOverview";
import { formatCurrencyFn, isEmpty } from "@util/utils";
import { appendSummaryRow } from "@icoach/accountBook/components/AccountBookOrderStatTemplate";

/**
 * 收入清單
 */
const TransactionList = memo(({ headerRow, defaultSearchParams, setItemTotalList, sumKeys }) => {
	const { getOrderStatisticsFilterItemsApi, getOrderStatisticsOptionsApi } = useOrderStatisticsApi();

	const { options } = useOptions({
		getOptionsApi: getOrderStatisticsOptionsApi,
		isFetchOnMount: true,
	});

	const { searchParams, overviewData, updateOverviewPage, updateOverviewSort, getOverviewData } = useOverview({
		getOverviewApi: getOrderStatisticsFilterItemsApi,
		defaultSearchParams: defaultSearchParams,
		isFetchOnMount: true,
		enableQueryString: false,
	});
	const { itemTotalList } = overviewData.meta;

	const handlePageChange = (_, page) => {
		updateOverviewPage(page);
	};

	const handleSortChange = value => {
		updateOverviewSort(value);
	};

	const isFistRenderRef = useRef(true);

	const list = useMemo(
		() => {
			if (isEmpty(overviewData?.list)) return [];
			return [...overviewData?.list, appendSummaryRow(overviewData?.list, headerRow, sumKeys)];
		},
		// eslint-disable-next-line
		[JSON.stringify(overviewData.list)]
	);

	useEffect(
		() => {
			if (!isFistRenderRef.current) {
				getOverviewData(defaultSearchParams);
			} else {
				isFistRenderRef.current = false;
			}
		},
		// eslint-disable-next-line
		[JSON.stringify(defaultSearchParams)]
	);

	useEffect(
		() => {
			if (!isEmpty(itemTotalList)) {
				setItemTotalList(itemTotalList);
			}
		},
		// eslint-disable-next-line
		[JSON.stringify(itemTotalList)]
	);
	
	return (
		<OverviewListLayout>
			<OverviewListLayout.Summary
				title={`${overviewData?.meta?.title || ""}, 總計:${formatCurrencyFn(overviewData?.meta?.totalPrice || 0, {
					symbol: "$",
				})}`}
				pageSortAndTotalProps={{
					pageIndex: overviewData?.pagination?.pageIndex,
					pageSize: overviewData?.pagination?.pageSize,
					totalCount: overviewData?.pagination?.totalCount,
					isCurrentPageLastIndex: true,
					sortDefaultValue: searchParams?.sortBy || 1,
					sortOptions: options?.orderByOptions,
					sortOnChange: handleSortChange,
					isSort: true,
				}}
			/>
			<OverviewListLayout.Table
				headerRow={headerRow}
				list={list}
				totalPage={overviewData?.pagination?.totalPage}
				pageIndex={overviewData?.pagination?.pageIndex}
				onChangePage={handlePageChange}
				isPagination
				isGray
			/>
		</OverviewListLayout>
	);
});

export default TransactionList;
